// extracted by mini-css-extract-plugin
export default {"bg":"footer_bg__K79TV"};